import { useEffect, useState } from 'react'
import { Box, Tabs, Tab, Typography, Avatar, Paper, Button, Grid } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary'
import FavoriteIcon from '@mui/icons-material/Favorite'
import moment from 'moment-timezone'

import { useParams } from 'react-router-dom'
import Axios from '../../config/axios'
import AddTributeModal from '../common/AddTributeModal'
import BookmarkPrompt from './BookmarkPrompt'

const MemorialScreen = () => {

    const { slug } = useParams()
    const [tabIndex, setTabIndex] = useState(0)
    const [isFetching, setIsFetching] = useState(true)
    const [memorial, setMemorial] = useState(null)
    const [openModal, setOpenModal] = useState(false);

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue)
    }

    const getMemorialData = () => {
        setIsFetching(true)
        Axios.get(`/digital-memorial/${slug}/`).then((res) => {
            setIsFetching(false)
            if (res && res?.data) {
                setMemorial(res?.data)
            }
        }).catch((err) => {
            console.log(err)
            setIsFetching(false)
            setMemorial(null)
        });
    }
    useEffect(() => {
        if (slug) {
            getMemorialData()
        }
    }, [slug])

    const tabContent = [
        {
            label: 'BIOGRAPHY',
            icon: <InfoIcon />,
            content: (
                <>
                    <Typography paragraph>
                        {(memorial && memorial.description) && <div dangerouslySetInnerHTML={{ __html: memorial.description }} />}
                    </Typography>
                </>
            )
        },
        {
            label: 'PHOTOS',
            icon: <PhotoLibraryIcon />,
            content: (
                <>

                    <Grid
                        container
                        justifyContent={{ xs: 'center', sm: 'flex-start' }}
                        rowSpacing={2}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                    >
                        {memorial?.photos?.length > 0 ? (
                            memorial.photos.map((item, i) => (
                                <Grid
                                    item
                                    xs={12} sm={3}
                                    key={i}
                                    sx={{
                                        mt: { xs: 2, sm: 0 },
                                        mx: { xs: 'auto', sm: 0 }
                                    }}
                                >
                                    <img
                                        src={item.photo}
                                        alt={`Photo ${i + 1}`}
                                        style={{
                                            width: '100%',
                                            height: '350px',
                                            objectFit: 'cover',
                                            borderRadius: '4px'
                                        }}
                                    />
                                    <div style={{ backgroundColor: '#f0f0f0', padding: '8px', textAlign: 'center', minHeight: '60px' }}>
                                        <Typography variant="body2">{item?.title}</Typography>
                                    </div>
                                </Grid>
                            ))
                        ) : (
                            <Grid item xs={12}>
                                <Grid container justifyContent="center" alignItems="center" mt={6} mb={6}>
                                    <Typography variant="body2">No Photos Found!</Typography>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>

                </>
            )
        },
        {
            label: 'TRIBUTES',
            icon: <FavoriteIcon />,
            content: (
                <>
                    <Box display="flex" alignItems="flex-center" justifyContent="end" gap={2} mt={2} mb={2}>
                        <Button
                            variant="outlined"
                            sx={{
                                height: '50px',
                                borderColor: '#ef4444',
                                borderRadius: '8px',
                                backgroundColor: '#ef4444',
                                color: '#fff',
                                '&:hover': {
                                    borderColor: '#dc2626',
                                    color: '#fff',
                                    backgroundColor: '#dc2626',
                                },
                                mb: 2
                            }}
                            className="add-item-button"
                            onClick={() => setOpenModal(!openModal)}
                        >
                            Add Tribute
                        </Button>
                    </Box>
                    {(memorial && memorial?.tributes && memorial?.tributes.length > 0) ? <>
                        {memorial?.tributes.map((item, index) => (
                            <Box key={index} display="flex" alignItems="flex-start" gap={2} mb={3}>

                                <Avatar sx={{ bgcolor: ' #1e5af9', width: 35, height: 35 }}>
                                    {item.name.charAt(0).toUpperCase()}
                                </Avatar>

                                <Box
                                    className="tribute-text speech-bubble w-100"
                                    sx={{
                                        position: 'relative',
                                        borderRight: '3px solid #1e5af9',
                                        borderBottom: '3px solid #1e5af9',
                                        borderRadius: '0px 12px 12px 12px',
                                        padding: '8px 16px',
                                        backgroundColor: '#f9f9f9',
                                        boxShadow: 1,
                                        marginLeft: -1.0,
                                        '&::after': {
                                            content: '""',
                                            position: 'absolute',
                                            top: '0px',
                                            left: '-10px',
                                            width: 0,
                                            height: 0,
                                            borderTop: '8px solid transparent',
                                            borderBottom: '8px solid transparent',
                                            borderRight: '8px solid #f9f9f9',
                                        },
                                    }}
                                >
                                    <Typography variant="body2" sx={{ whiteSpace: 'pre-line', overflowWrap: 'anywhere' }}>
                                        {item.message}
                                    </Typography>
                                    <Typography variant="body2" fontWeight="bold" sx={{ marginTop: 1 }}>
                                        - {item.name}
                                    </Typography>
                                </Box>


                            </Box>
                        ))}
                    </> : <>
                        <Box display="flex" alignItems="flex-center" justifyContent="center" gap={2} mt={6} mb={6}>
                            <Typography variant="body2">No Tributes Found!</Typography>
                        </Box>
                    </>}
                </>
            )
        }

    ]

    return (
        <>
            <div style={{ background: 'linear-gradient(180deg,#dde5fc,#f2f4f7 80%)' }}>
                <div className='About_Container memorial_container container py-5' style={{ minHeight: '100vh' }}>
                    {(memorial) ? <>
                        <Grid container direction="column" position={'relative'}>
                            <Grid
                                item
                                sx={{
                                    position: 'relative',
                                    height: { xs: '300px', sm: '450px' },
                                    backgroundImage: `${memorial?.cover_photo ? `url(${memorial.cover_photo})` : ''}`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'top',
                                    borderRadius: 2,
                                    width: '100%',
                                    margin: 0
                                }}
                            >
                                <Grid
                                    container
                                    sx={{
                                        position: 'absolute',
                                        bottom: { xs: -250, sm: -160 },
                                        left: 0,
                                        px: 2
                                    }}
                                    alignItems="center"
                                    justifyContent={{ xs: 'center', sm: 'flex-start' }}
                                    direction={{ xs: 'column', sm: 'row' }}
                                >
                                    {memorial?.profile_photo && (
                                        <Avatar
                                            src={memorial.profile_photo}
                                            sx={{
                                                width: "200px",
                                                height: "200px",
                                                border: '3px solid white',
                                                mb: { xs: 2, sm: 0 },
                                                mr: { xs: 0, sm: 2 },
                                                borderRadius: 1
                                            }}
                                        />
                                    )}
                                    <Box sx={{ marginLeft: { xs: 0, md: '16px' }, marginTop: { xs: 0, md: '30px' }, textAlign: { xs: 'center', md: 'left' } }}>
                                        <Typography variant="h5" fontWeight="bold" noWrap={false} sx={{ textAlign: { xs: 'center', sm: 'center', md: 'left' }}}>
                                            {memorial?.name}
                                        </Typography>
                                        <Typography variant="subtitle1" noWrap={false}>
                                            {`${moment(memorial?.from_date).format('LL')} - ${moment(memorial?.to_date).format('LL')}`}
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>

                            <div style={{ position: 'absolute', top: '20px', right: '20px' }} zIndex={1000}>
                                <BookmarkPrompt />
                            </div>

                            <div style={{ height: window.innerWidth < 600 ? 270 : 225 }} />

                            <Paper square variant='outline' style={{ width: '100%', background: 'transparent' }}>
                                <Tabs
                                    value={tabIndex}
                                    onChange={handleTabChange}
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    sx={{
                                        '& .MuiTabs-indicator': {
                                            backgroundColor: '#1e5af9'
                                        }
                                    }}
                                >
                                    {tabContent.map((tab, index) => (
                                        <Tab
                                            key={index}
                                            icon={(window.innerWidth < 600) ? null : tab.icon}
                                            label={tab.label}
                                            iconPosition="start"
                                            disableRipple
                                            sx={{
                                                marginRight: 2,
                                                minHeight: 48,
                                                px: 1.5,
                                                textTransform: 'none',
                                                fontWeight: 500,
                                                backgroundColor: '#cacaca',
                                                color: '#000',
                                                '&.Mui-selected': { backgroundColor: '#1e5af9', color: '#FFF' },
                                                '&:hover': { backgroundColor: '#1e5af9', color: '#FFF' },
                                            }}
                                        />
                                    ))}
                                </Tabs>
                            </Paper>
                            
                            <Paper style={{ width: '100%', padding: '25px', marginTop: '16px' }}>
                                <Grid item style={{ width: '100%' }}>
                                    <div style={{ textAlign: 'justify' }}>
                                        {tabContent[tabIndex]?.content}
                                    </div>
                                </Grid>
                            </Paper>
                        </Grid>
                    </> : <>
                        {(!isFetching && memorial === null) && <>
                            <Grid container direction="column">
                                <Grid item>
                                    <h3 style={{ textAlign: 'center', paddingTop: "10%" }}>
                                        Not Found
                                    </h3>
                                    <div style={{ textAlign: 'center', color: 'gray' }}>
                                        Oops! No Digital Memorial matches the provided QR code
                                    </div>
                                </Grid>
                            </Grid>
                        </>}
                    </>}
                </div>
            </div>


            {openModal && memorial && (
                <AddTributeModal
                    open={openModal}
                    setOpen={setOpenModal}
                    itemId={memorial?.id}
                    getList={getMemorialData}
                />
            )}
        </>
    )
}

export default MemorialScreen
